import React, { Component } from 'react';
import CtHead from './CtHead/CtHead';
import * as api from '../../api';
import Okupace from './Okupace/Okupace';
import * as SoundManager from '../../utils/SoundManager';
import * as Features from '../../utils/Features';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.checkIntro();
  }

  // -------------------------------------------------------
  // Lifecycle
  // -------------------------------------------------------

  componentWillMount() {
    api.initHash();
    Features.init();
  }

  checkIntro() {
    SoundManager.initMusic();
    return false;
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    return (
      <div id="app">
        <CtHead />
        <Okupace />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js